import {
  SET_PAGE_LOAD,
  CLEAR_PAGE_LOAD,
  PROGRESS_LOADING
} from '@/application/redux/types.d';

const initailState = {
  pageload: null,
  progress: null
};

// eslint-disable-next-line default-param-last
const noti = (state = initailState, action: any) => {
  switch (action.type) {
    case SET_PAGE_LOAD:
      return {
        ...state,
        pageload: true
      };

    case CLEAR_PAGE_LOAD:
      return {
        ...state,
        pageload: false
      };

    case PROGRESS_LOADING:
      return {
        ...state,
        progress: action.progress
      };

    default:
      return state;
  }
};

export default noti;